import { QuestionType } from "../enums/question-type.enum";

export interface Question {
  question: string;
  type: QuestionType;
  required: boolean;
}

export abstract class BasicQuestion implements Question {
  question: string;
  type: QuestionType;
  required: boolean;
  constructor(question: string, type: QuestionType, required: boolean = true) {
    this.question = question;
    this.type = type;
    this.required = required;
  }

  toJSON() {
    return {
      question: this.question,
      type: this.type,
      required: this.required
    };
  }
  get typeAsString(): string {
    return QuestionType[this.type];
  }
}

export class ShortAnswerQuestion extends BasicQuestion {
  constructor(question: string, required: boolean = true) {
    super(question, QuestionType.ShortAnswer, required);
  }

  toJSON = () => super.toJSON();
}

export abstract class SelectQuestion extends BasicQuestion {
  options: string[];
  constructor(
    question: string,
    options: string[],
    type: QuestionType,
    required: boolean = true
  ) {
    super(question, type, required);
    this.options = options;
  }

  toJSON() {
    return {
      question: this.question,
      type: this.type,
      required: this.required,
      options: this.options
    };
  }
}

export class SelectOneQuestion extends SelectQuestion {
  constructor(question: string, options: string[], required: boolean = true) {
    super(question, options, QuestionType.SelectOne, required);
  }
}

export class SelectManyQuestion extends SelectQuestion {
  constructor(question: string, options: string[], required: boolean = true) {
    super(question, options, QuestionType.SelectMany, required);
  }
}

export class SelectManyWithLimitQuestion extends SelectQuestion {
  limit: number;
  constructor(
    question: string,
    options: string[],
    limit: number,
    required: boolean = true
  ) {
    super(question, options, QuestionType.SelectManyWithLimit, required);
    this.limit = limit;
  }

  toJSON() {
    return {
      question: this.question,
      type: this.type,
      options: this.options,
      limit: this.limit,
      required: this.required
    };
  }
}
